import React, { Fragment } from 'react'
import styled from '@emotion/styled'
import { type ScopedRouteParams, AsyncStatus } from 'legacy/common/types'
import { type RetailerRouteComponentProps } from 'legacy/components/RetailerRoute'
import { withTrackEventOnMount } from 'utils/events/hocs'
import NewProductContainer from './NewProductContainer'
import NewProductForm from './NewProductForm'
import RequestNewProductBreadcrumbs from 'legacy/routes/catalog/breadcrumbs/RequestNewProductBreadcrumbs'
import AppHeader from 'legacy/components/AppHeader'

const OuterContainer = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const InnerContainer = styled.div`
  max-width: 960px;
  padding: 20px;
`

export interface RouteParams extends ScopedRouteParams {
  product_id: string
}

interface OwnProps {
  match: {
    params: RouteParams
  }
}

type Props = OwnProps & RetailerRouteComponentProps<RouteParams>

class NewProduct extends React.Component<Props> {
  handleSuccess = () => {
    const { history, url } = this.props
    history.push(url('departments'))
  }

  render() {
    const {
      match: { params },
    } = this.props

    return (
      <Fragment>
        <AppHeader title={<RequestNewProductBreadcrumbs />} />
        <OuterContainer>
          <InnerContainer>
            <NewProductContainer {...params} onSuccess={this.handleSuccess}>
              {({ product, onRequestNewProduct, requestNewProductStatus }) => (
                <NewProductForm
                  isSubmitting={requestNewProductStatus === AsyncStatus.Busy}
                  product={product}
                  onSubmit={onRequestNewProduct}
                />
              )}
            </NewProductContainer>
          </InnerContainer>
        </OuterContainer>
      </Fragment>
    )
  }
}

export default withTrackEventOnMount({
  id: 'catalog.products.new_product.viewed',
  description: 'Viewed the Request New Product page',
})(NewProduct)
